import { render } from "./TeamSettings.vue?vue&type=template&id=4eee0e1e"
import script from "./TeamSettings.vue?vue&type=script&lang=js"
export * from "./TeamSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/settings/TeamSettings.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4eee0e1e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4eee0e1e', __exports__)) {
    api.reload('4eee0e1e', __exports__)
  }
  
  module.hot.accept("./TeamSettings.vue?vue&type=template&id=4eee0e1e", () => {
    api.rerender('4eee0e1e', render)
  })

}


export default __exports__